import { render, staticRenderFns } from "./FlowStepUphold.vue?vue&type=template&id=4e54caa3&scoped=true"
import script from "./FlowStepUphold.vue?vue&type=script&lang=ts"
export * from "./FlowStepUphold.vue?vue&type=script&lang=ts"
import style0 from "./FlowStepUphold.vue?vue&type=style&index=0&id=4e54caa3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e54caa3",
  null
  
)

export default component.exports